import { CustomFieldInputComponent } from "../CustomFieldsForm";
import { TextField } from "@mui/material";
import { testIds } from "./StringCustomFieldInput.testIds";

const StringCustomFieldInput: CustomFieldInputComponent = ({
  value,
  customFieldDefinition,
  onChange,
  disabled,
}) => {
  return (
    <TextField
      onChange={(event) => {
        onChange(event.target.value);
      }}
      value={String(value || "")}
      size="medium"
      fullWidth
      disabled={disabled}
      label={customFieldDefinition.label}
    inputProps={{ "data-testid": testIds.stringCustomFieldInputValue } as React.InputHTMLAttributes<HTMLInputElement>}
    />
  );
};

export default StringCustomFieldInput;
